import { call, put } from 'redux-saga/effects';
import { getSelectedIssue } from "../../../lib/utilities/index";

const fetchSelectedIssueData = async () => {
    try {
        const issueId = window.location.pathname.split("/").pop();
        let selectedIssue = await getSelectedIssue(issueId);
        return {
            selectedIssue
        }
    } catch (e) {
        console.log(e);
        throw e;
    }
}

function* fetchSelectedIssueDataSaga(action) {
    try {
        const {
            selectedIssue
        } = yield call(fetchSelectedIssueData);
        yield put({
            type: 'FETCH_SELECTED_ISSUE_DATA_SUCCESSFUL',
            selectedIssue
        })
    } catch (e) {
        yield put({ type: 'FETCH_SELECTED_ISSUE_DATA_FAILED', error: e.message });
    }
}

export default fetchSelectedIssueDataSaga;